import React from 'react'

type LayoutProps = {
  children: React.ReactNode
}

const DefaultLayout = ({ children }: LayoutProps) => (
  <div className="flex flex-col min-h-screen bg-slate-900">
    <div className="mx-auto my-4">{children}</div>
  </div>
)

export default DefaultLayout
